module.exports = __webpack_public_path__ + "static/img/wxpubTutorial_bg_duihaoli.2f8567a6.png";